import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

import { useAppSelector } from '_src/store/hooks'
import Theme from '_src/components/Theme'

import { getNavigationsList, getWeMediaList } from '_src/servers/v1/navigations'

import { NavsSkeleton, MediaSkeleton } from './components/footerSkeleton'

import './index.less'

const InftFooter = ({ className }) => {
  let history = useHistory()
  const { networkId, lng, theme } = useAppSelector((store) => store.global)

  const [navslist, setNavsList] = useState([])
  const [mediaList, setMediaList] = useState([])

  const handlePush = (item) => {
    const { is_skip, skip_target, url } = item
    // is_skip 是否跳转 1 是 0 否
    // skip_target 跳转方式 1 在外部链接打开 2 本页面内部跳转
    if (is_skip == 1) {
      if (skip_target == 1) {
        url && window.open(url)
      } else {
        url &&
          history.push({
            pathname: url,
          })
      }
    }
  }

  // 获取底部导航
  const getNavigations = async () => {
    try {
      const res = await getNavigationsList({ type: 2, chain_id: networkId })
      if (res && res.code == 1000) {
        const {
          data: { list = [] },
        } = res
        if (list) {
          setNavsList(list)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 获取媒体列表
  const getMediaList = async () => {
    try {
      const res = await getWeMediaList({
        chain_id: networkId,
        page: 1,
        page_size: 10,
      })
      if (res && res.code == 1000) {
        const {
          data: { list = [] },
        } = res
        if (list) {
          setMediaList(list)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getNavigations()
    getMediaList()
  }, [networkId, lng])
  return (
    <div className={classNames('inft-footer', className)}>
      <div className="footer-container">
        <div className="left-container">
          {navslist.length == 0 ? (
            <NavsSkeleton />
          ) : (
            <>
              {navslist.map((item) => (
                <div className="container-item" key={item.id}>
                  <div className="text-header">{item.name}</div>
                  {item?.Children &&
                    item.Children.map((it) => (
                      <div
                        className="text-container"
                        key={it.id}
                        onClick={() => {
                          handlePush(it)
                        }}
                      >
                        {it.name}
                      </div>
                    ))}
                </div>
              ))}
            </>
          )}
        </div>
        <div className="right-container">
          <div className="right-container-img">
            {mediaList.length == 0 ? (
              <MediaSkeleton />
            ) : (
              mediaList.map(
                (item) =>
                  item.icon && (
                    <img
                      className="media-icon"
                      onClick={() => {
                        handlePush(item)
                      }}
                      src={theme === 'dark' ? item.dark_icon_url : item.icon}
                      key={item.id}
                    />
                  )
              )
            )}
          </div>
          <Theme />
        </div>
      </div>
    </div>
  )
}

export default InftFooter
